import { inject } from '@angular/core';
import { Router, CanMatchFn } from '@angular/router';
import { AuthFacadeService } from 'ngpd-merceros-authentication-fe-components';
import {
    AUTHENTICATION_CONFIG,
    AuthenticationConfig,
    AuthenticationService,
} from 'ngpd-merceros-authentication-fe-components/core';

export const NoAuthGuardMatch: CanMatchFn = () => {
    const _authConfig: AuthenticationConfig = inject(AUTHENTICATION_CONFIG);
    const _authFacade = inject(AuthFacadeService);
    const _authService = inject(AuthenticationService);

    const _router = inject(Router);

    const token = _authService.getSessionToken();
    const refreshToken = _authService.getRefreshToken();

    if (token && refreshToken) {
        _router.navigate([_authConfig.common.loginSuccessRoute]);
        return false;
    }
    return true;
};
